/* eslint-disable max-len */
/* eslint-disable no-console */
/**
 * API_Name: Permanet_Delete
 * Type: Custome Hooks
 */
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import useFetchTrash from '../customHooks/useFetchTrash';
import { MediaContext } from '..';
import { permanentDelete } from '../../actions/media_actions';
import { toast } from 'react-toastify';
import useGetSharedItems from './useGetSharedItems';
import { LanguageContext } from '../../../libs/Context';

const usePermanentDelete = () =>
{
	const userData = useSelector((state:any) => state?.mysession?.session);
	const getTrashDataInfo = useFetchTrash();
	const { mediaState, setMediaState } = useContext(MediaContext);
	const tab = useParams()?.tab || '';
	const getSharedList = useGetSharedItems(mediaState, setMediaState);
	const { language } = useContext(LanguageContext);

	const deletePermanently = async ({ idArray, fromUpload = false, setLoading = () => {} }:any) =>
	{
		setLoading(true);
		const body:any = { id: idArray };
		const query: any = {
			uid     : userData?.userId,
			comid   : userData?.companyId,
			empRole : userData?.empRole,
			role    : userData?.role
		};

		if (fromUpload) query.fromUpload = true;
		else if (tab === 'shared') query.fromShare = true;

		try
		{
			const response = await permanentDelete(query, body);

			if (response?.status)
			{
				mediaState?.selectedData?.length > 0 && setMediaState({ type: 'updateReducer', payload: { selectedData: [], allSelected: false } });
				if (!fromUpload)
				{
					mediaState?.page > 0
						? setMediaState({ type: 'updateReducer', payload: { page: 0 } })
						: (tab === 'shared') ? getSharedList() : getTrashDataInfo();

					toast.success(language.folderorFilePermanentlyDeleted, {
						position  : toast.POSITION.TOP_RIGHT,
						className : 'toast-message'
					});
				}

				setLoading(false);
			}
			else
			{
				setLoading(false);
			}
		}
		catch (error)
		{

		}
	};

	return deletePermanently;
};

export default usePermanentDelete;